import React from "react";
import { ExerciseInt } from "../../../models/ExerciseInt";

interface IProps {
  exercise: ExerciseInt;
  onSelect: (exercise: ExerciseInt) => void;
  isSelected: boolean;
}

const GdanskLaneExerciseTile: React.FC<IProps> = ({ exercise, onSelect, isSelected }) => {
  const isFull = exercise.reserved >= exercise.capacity;

  const tileClassName = `${isFull ? "full" : "available"} ${isSelected ? "selected" : ""}`;

  const handleSelect = () => {
    if (!isFull) {
      onSelect(exercise);
    }
  };

  return (
    <div className={`exercise-tile ${tileClassName}`} onClick={handleSelect}>
      <p className="no-line-height">
        {isFull ? "BRAK MIEJSC" : isSelected ? "WYBRANO" : `WYBIERZ (${exercise.reserved}/${exercise.capacity})`}{" "}
      </p>
    </div>
  );
};

export default GdanskLaneExerciseTile;
